
// client/src/components/pages/TermsAndConditionsPage.js
import React, { useState, useEffect } from 'react';
import './LegalPage.css'; // Using the shared stylesheet

const TermsAndConditionsPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`legal-page-wrapper ${isVisible ? 'is-visible' : ''}`}>
      <div className="legal-page-container">
        <h1>Terms and Conditions</h1>
        <span className="last-updated">Last Updated: July 25, 2025</span>

        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>
        
        <h2>2. Use of the Website</h2>
        <p>This website is intended to provide information about the products and services offered by Makah Medics. The content is for informational purposes only and is primarily directed at healthcare professionals and institutions. The information provided is not a substitute for professional medical advice.</p>
        
        <h2>3. Quote Requests</h2>
        <p>A "Request a Quote" submitted through this website is an inquiry for information and pricing. It does not constitute a binding purchase order or a contract for sale. Makah Medics reserves the right to respond to, or decline, any quote request at its sole discretion. All sales are subject to a separate, formal sales agreement.</p>
        
        <h2>4. Intellectual Property</h2>
        <p>The content, logos, graphics, and other materials on this website are the property of Makah Medics and are protected by copyright and other intellectual property laws. Unauthorized use, reproduction, or distribution is strictly prohibited.</p>
        
        <h2>5. Disclaimer of Warranties</h2>
        <p>This website and its content are provided "as is." Makah Medics makes no warranties, expressed or implied, regarding the accuracy, reliability, or completeness of the content.</p>

        <h2>6. Limitation of Liability</h2>
        <p>Makah Medics shall not be liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use this website or its content.</p>

        <h2>7. Governing Law</h2>
        <p>These terms and conditions are governed by and construed in accordance with the laws of the United Republic of Tanzania.</p>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;